import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SponsorshipRoutingModule } from './sponsorship-routing.module';
import { SponsorshipListComponent } from './components/sponsorship-list/sponsorship-list.component';
import { SponsorshipManagementComponent } from './components/sponsorship-management/sponsorship-management.component';

@NgModule({
  declarations: [SponsorshipListComponent, SponsorshipManagementComponent ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    SponsorshipRoutingModule
  ]
})
export class SponsorshipModule { }
